import { z } from 'zod'

export const GetVariantByIdSchema = z.object({
    variant_id: z.string().min(1),
})
